import React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import Info from "../../img/Info.svg";
import { useTranslation } from "react-i18next";

const TelemedicineAbuseInfo = ({
  activeConsultation,
  showTelemedicineAbuseModal,
  closeBanner,
}) => {
  const { t } = useTranslation(["consultations"]);
  const { dispensingLimit } = activeConsultation;
  if (dispensingLimit) {
    return (
      <div
        style={{
          position: "fixed",
          top: 150,
          backgroundColor: "#FFFAF2",
          width: "75vw",
          fontSize: 16,
          padding: 10,
          color: "#323539",
        }}
      >
        <div
          style={{ display: "flex", justifyContent: "space-between", gap: 30 }}
        >
          <div style={{ display: "flex", gap: 8 }}>
            <div>
              <img src={Info} alt="Info" />
            </div>
            <div>
              {dispensingLimit.count < dispensingLimit.limit
                ? t("dispensingBelowLimitCountMessage")
                : t("dispensingAboveLimitCountMessage")}
              <p
                onClick={showTelemedicineAbuseModal}
                style={{
                  cursor: "pointer",
                  color: "#094063",
                }}
              >
                {t("learnMore")}
              </p>
            </div>
          </div>
          <div
            style={{ fontSize: 16, fontWeight: "bolder", cursor: "pointer" }}
            onClick={closeBanner}
          >
            X
          </div>
        </div>
        <div></div>
      </div>
    );
  } else return null;
};

const mapStateToProps = (store) => {
  const { consultation } = store;
  return {
    prescriptions: consultation?.prescriptions,
    activeConsultation: consultation?.active || {},
  };
};

export default withRouter(connect(mapStateToProps)(TelemedicineAbuseInfo));
